import { render, staticRenderFns } from "./caseBlock.vue?vue&type=template&id=04bd3324&"
import script from "./caseBlock.vue?vue&type=script&lang=js&"
export * from "./caseBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports